import {
  LocationHazardProps,
  LocationHazardViewModelBase,
} from 'src/store/generated/location-hazard-record.generated';
import { LocationViewModel } from './location-view-model';

export class LocationHazardViewModel extends LocationHazardViewModelBase {
  constructor(locationHazard: LocationHazardProps, public readonly location: LocationViewModel) {
    super(locationHazard);
  }
}
